import { render, staticRenderFns } from "./ActiveAssignmentWidget.vue?vue&type=template&id=a115babc&scoped=true&"
import script from "./ActiveAssignmentWidget.vue?vue&type=script&lang=js&"
export * from "./ActiveAssignmentWidget.vue?vue&type=script&lang=js&"
import style0 from "./ActiveAssignmentWidget.vue?vue&type=style&index=0&id=a115babc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a115babc",
  null
  
)

export default component.exports